import { actionsToArray } from '@noven-prime/lattice-core';
import { portalSettingsActions } from './actions.js';
/**
 * Portal Settings Capability Manifest
 *
 * Admin-only portal configuration: LLM provider credentials and model
 * selection. Stored in the private `portal` blob container.
 */
export const portalSettingsManifest = {
    id: 'portal-settings',
    name: 'Portal Settings',
    description: 'Manage portal configuration — LLM credentials and model selection',
    version: '1.0.0',
    surfaces: {
        allowed: '*',
    },
    experiences: {
        allowed: '*',
    },
    actions: actionsToArray(portalSettingsActions),
    features: [
        {
            id: 'settings-management',
            name: 'Settings Management',
            description: 'View and update portal settings',
            actions: actionsToArray(portalSettingsActions),
        },
    ],
};
//# sourceMappingURL=manifest.js.map